// extracted by mini-css-extract-plugin
export var filterIncDec = "_4a-0";
export var leftBorder = "_4a-1";
export var rightBorder = "_4a-2";
export var stringInput = "_4a-3";